import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TabMenu from "./components/TabMenu";
import Home from "./pages/Home";
import Content from "./pages/Content";
import Contact from "./pages/Contact";
import Reviews from "./pages/Reviews";
import "./App.css";

const App = () => {
  return (
    <Router>
      <div className="site-bg min-h-screen flex flex-col">
        <TabMenu />
        <div className="flex-1 flex pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/content" element={<Content />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reviews" element={<Reviews />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
